export default __webpack_public_path__ + "static/media/cover2.fd9a8f02.webp";